<template>
<div>
    <table class="table table-striped table-bordered w-100 tabla-default">
        <thead>
            <tr>
                <th>Estado</th>
                <th>Canal</th>
                <th>Medio</th>
                <th>Última Actualización</th>
                <th>Opciones</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="interaccion in interacciones">
                <td>{{ interaccion.estado }}</td>
                <td>{{ interaccion.canal }}</td>
                <td>{{ interaccion.medio }}</td>
                <td>{{ interaccion.ultima_actualizacion }}</td>
                <td>
                    <div class="btn-group">
                        <button data-toggle="dropdown" class="btn btn-primary dropdown-toggle"> Opciones</button>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" @click.prevent="mostrarModalHistorial(interaccion.id_inter_global)"> Ver Historial</a></li>
                        </ul>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>

    <historial-modal-component ref="ModalHistorial" />
</div>
</template>

<script>
import HistorialModalComponent from "../../modals/HistorialModalComponent";

export default {
    name: "ReporteConversaciones",
    components: { HistorialModalComponent },
    props: ["interacciones"],
    data: function () {
        return {
           //
        };
    },
    mounted: function() {
        console.log('mounted');
    },
    methods: {
        mostrarModalHistorial(inter_global) {
            console.log(inter_global);
            this.inter_global = inter_global
            this.$refs.ModalHistorial.show(inter_global)
        },
    }
};
</script>
